import { HashLink } from "react-router-hash-link"
import { Link } from "react-router-dom"
import React, { FC, ReactNode } from "react"

type RRNavLinkProps = {
  to: string
  children: ReactNode
  width?: string
  noWrap?: boolean
  active?: boolean
  hash?: boolean
  top?: boolean
}

/**
 * A Link element intended for composition within a RoundedRectangle
 */
const RRNavLink: FC<RRNavLinkProps> = ({
  to,
  children,
  width = "",
  noWrap = false,
  active = false,
  hash = false,
  top = false
}) => {
  const wrap = noWrap ? "nowrap" : ""
  const LinkComponent = hash ? HashLink : Link
  const linkClasses = `w-100 black-70 no-underline dim ${wrap}`
  const wrapperClasses = `flex flex-wrap flex-grow-1 min-w150px f6 ${top ? "" : "mt2"} lh-copy ${width}`

  return (
    <nav className={wrapperClasses}>
      {active ? (
        <div className="flex items-center">
          <div className="dib nl3 w-8px h-2px bg-white" />
          <div className={`ml2 fw5 black-80 dib ${wrap}`}>{children}</div>
        </div>
      ) : (
        <LinkComponent className={linkClasses} to={to}>
          {children}
        </LinkComponent>
      )}
    </nav>
  )
}

export { RRNavLink }
